var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandFrameOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.09778H8C8.55228 3.09778 9 3.54549 9 4.09778C9 4.65006 8.55228 5.09778 8 5.09778H7C5.73684 5.09778 5 5.83462 5 7.09778V8.0979C5 8.65018 4.55228 9.0979 4 9.0979C3.44772 9.0979 3 8.65019 3 8.0979V7.09778C3 4.85217 4.75439 3.09778 7 3.09778Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.0979C3.44772 15.0979 3 15.5456 3 16.0979V17.0978C3 19.3434 4.75439 21.0978 7 21.0978H8C8.55228 21.0978 9 20.6501 9 20.0978C9 19.5455 8.55228 19.0978 8 19.0978H7C5.73684 19.0978 5 18.3609 5 17.0978V16.0979C5 15.5456 4.55228 15.0979 4 15.0979Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.0979C19.4477 15.0979 19 15.5456 19 16.0979V17.0978C19 18.3609 18.2632 19.0978 17 19.0978H16C15.4477 19.0978 15 19.5455 15 20.0978C15 20.6501 15.4477 21.0978 16 21.0978H17C19.2456 21.0978 21 19.3434 21 17.0978V16.0979C21 15.5456 20.5523 15.0979 20 15.0979Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.0979C20.5523 9.0979 21 8.65019 21 8.0979V7.09778C21 4.85217 19.2456 3.09778 17 3.09778H16C15.4477 3.09778 15 3.54549 15 4.09778C15 4.65006 15.4477 5.09778 16 5.09778H17C18.2632 5.09778 19 5.83462 19 7.09778V8.0979C19 8.65019 19.4477 9.0979 20 9.0979Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandFrameOutlined);
export default __webpack_public_path__ + "static/media/expand_frame_outlined.331c4b58.svg";
export { ForwardRef as ReactComponent };